import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { useTheme } from '@mui/material';
import { MagnifyingGassIcon, SearchCloseIcon } from 'app/components/Icons';
import { ButtonPrimary } from 'app/components/ButtonPrimary';
import { serializeOnlyNumbers } from 'app/utils/normalizer';
import {
  ButtonArea,
  StyledButtonIcon,
  StyledContainer,
  StyledIcon,
  StyledSearchInput,
  StyledSearchWrapper,
  StyledSpan,
} from './SearchInput.styles';
import { TextM } from 'app/components/typography';
import { isValidCPF } from 'app/utils/validations';

export interface ISearchInputProps {
  placeholder?: string;
  textButton?: string;
  searchHandler: (value: string) => void;
  label?: string;
}

const SearchInput = ({
  placeholder,
  textButton,
  searchHandler,
  label,
}: ISearchInputProps) => {
  const theme = useTheme();

  const [errorMessage, setErrorMessage] = useState<string>();
  const [inputValue, setInputValue] = useState<string>('');

  useEffect(() => {
    const cpf = inputValue.replace(/\D+/g, '');
    if (cpf.length === 11 && !isValidCPF(cpf)) {
      setErrorMessage('CPF inválido');
    }
  }, [inputValue]);

  return (
    <>
      {label && (
        <TextM weight="Bold" style={{ marginBottom: '10px' }}>
          {label}
        </TextM>
      )}
      <StyledSearchWrapper>
        <StyledContainer>
          <StyledSearchInput>
            <StyledIcon>
              <MagnifyingGassIcon
                color={theme.palette.brand.gray[500] as string}
              />
            </StyledIcon>
            <InputMask
              mask="999.999.999-99"
              placeholder={placeholder}
              value={inputValue}
              onKeyDown={(e) =>
                e.key === 'Enter' &&
                serializeOnlyNumbers(inputValue).length === 11 &&
                isValidCPF(serializeOnlyNumbers(inputValue)) &&
                searchHandler(serializeOnlyNumbers(inputValue))
              }
              onChange={(e) => {
                setInputValue(e.target.value);
                setErrorMessage(undefined);
              }}
            >
              {(inputProps) => <input {...inputProps} />}
            </InputMask>

            {inputValue && (
              <ButtonArea onClick={() => setInputValue('')}>
                <SearchCloseIcon
                  color={theme.palette.brand.primary.base as string}
                  size={14}
                />
              </ButtonArea>
            )}
          </StyledSearchInput>

          <StyledSpan style={{ color: 'red' }}>{errorMessage}</StyledSpan>
        </StyledContainer>

        <ButtonPrimary
          onClick={() => searchHandler(serializeOnlyNumbers(inputValue))}
          style={{ width: '17rem', marginLeft: '2rem' }}
          disabled={
            serializeOnlyNumbers(inputValue).length !== 11 || !!errorMessage
          }
        >
          <div>{textButton ?? 'Buscar'}</div>
          <StyledButtonIcon>
            <MagnifyingGassIcon
              color={theme.palette.brand.gray[100] as string}
            />
          </StyledButtonIcon>
        </ButtonPrimary>
      </StyledSearchWrapper>
    </>
  );
};

export default SearchInput;
